import { render, staticRenderFns } from "./segmentosEditar.vue?vue&type=template&id=8e70dbc4&scoped=true&"
import script from "./segmentosEditar.vue?vue&type=script&lang=js&"
export * from "./segmentosEditar.vue?vue&type=script&lang=js&"
import style0 from "./segmentosEditar.vue?vue&type=style&index=0&id=8e70dbc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e70dbc4",
  null
  
)

export default component.exports